import { useForgotPasswordMutation } from 'util/rtk-api'
import { useDocTitle } from 'util/hooks'

import React, { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { showMutationError } from 'util/mutation-error'
import { AuthCard, AuthDivider } from 'auth/auth-card'

export const ForgotPassword = () => {
	const searchParams = new URLSearchParams(window.location.search)
	const from = searchParams.get('from')
	const fromSettings = from === 'settings'
	const navigate = useNavigate()
	const [ forgotPassword ] = useForgotPasswordMutation()

	const [ email, setEmail ] = useState('')

	const onFormSubmit = async event => {
		event.preventDefault()
		const result = await forgotPassword({ username: email })

		if (showMutationError(result)) return

		navigate(
			`/reset-password?email=${email}`
			+ (from ? `&from=${from}` : '')
		)
	}

	useDocTitle('All for One - Forgot Password')

	return (
		<AuthCard
			eyebrow={fromSettings ? 'Your account' : 'Reset password'}
			title={fromSettings ? 'Update password' : 'Forgot password?'}
			/* The real flow emails a one-time CODE, not a link, so the copy says code (the design's
			   "link" wording would describe something we do not send). */
			subtitle={fromSettings
				? 'Enter your email and we’ll send you a code to confirm it’s you.'
				: 'Enter your email and we’ll send you a code to reset your password.'}
		>
			{!fromSettings && (
				<div className="auth-note">
					If you’re a student, ask your teacher for help logging in first.
				</div>
			)}

			<form
				id="forgot-password-form"
				action="#"
				method="POST"
				onSubmit={onFormSubmit}
			>
				<div className="auth-field">
					<label htmlFor="email" className="auth-field-label">Email</label>
					{/* No example address as a placeholder: the design's sample address read as
					    pre-typed text (Aeryn, 2026-11-04). The label names the field. */}
					<input
						type="email"
						id="email"
						name="email"
						placeholder="Email"
						required
						value={email}
						onChange={({ target }) => setEmail(target.value)}
					/>
				</div>

				<button type="submit" className="auth-btn">Send code</button>
			</form>

			<AuthDivider />

			<p className="auth-prompt">
				{fromSettings ? 'Changed your mind?' : 'Remember your password?'}{' '}
				<Link
					to={fromSettings ? '/settings' : '/login'}
					className="auth-link"
				>{fromSettings ? 'Back to settings' : 'Log in'}</Link>
			</p>
		</AuthCard>
	)
}
